import IWallMetaData from '../../components/interfaces/IWallMetaData';
import glassWallPartTypes from '../../components/configurator/types/glassWallPartTypes';

const openSaveData = (
  data: string,
  walls: IWallMetaData[],
  callback: () => void
): void => {
  const loader = new THREE.FontLoader();
  loader.load('/Fonts/Arial Narrow_Regular.json', (response: any) => {
    window.SetFont(response);

    let parts = JSON.parse(data);

    // Fix for saved configurations without wallName and doorGlassNames
    parts.forEach((part: any) => {
      const wall = walls.find(
        (w: IWallMetaData) => w.identifier === part.wallID
      );
      if (part.wallProps != null) {
        part.wallProps.wallName = wall != null ? wall.name : '';
      }
      if (part.wallProps != null && !part.wallProps.woodyDoorPositionOffset) {
        part.wallProps.woodyDoorPositionOffset = 0;
      }

      if (
        part.wallComponents != null &&
        part.wallComponents.doorGlassNames == null
      ) {
        part.wallComponents.forEach((wallComponent: any) => {
          if (
            wallComponent != null &&
            wallComponent.doorGlassNames == null &&
            wallComponent.type === glassWallPartTypes.door
          ) {
            wallComponent.doorGlassNames = emptyDoorGlassNames();
          }
        });
        /*
        const eboxprops = [
          'woodyLeftElectricalBox',
          'woodyRightElectricalBox',
          'woodyLeftElectricalBoxWidth',
          'woodyRightElectricalBoxWidth',
        ];
        eboxprops.forEach((prop) => {
          if (!part.wallProps[prop]) {
            part.wallProps.parts.forEach((wallPropPart: any) => {
              if (wallPropPart != null && wallPropPart[prop] != null) {
                part.wallProps[prop] = wallPropPart[prop];
              }
            });
          }
        });
*/
        part.wallProps.parts.forEach((wallPropPart: any) => {
          if (
            wallPropPart != null &&
            wallPropPart.doorGlassNames == null &&
            wallPropPart.type === glassWallPartTypes.door
          ) {
            wallPropPart.doorGlassNames = emptyDoorGlassNames();
          }
        });

        part.wallProps.doorGlassNames = emptyDoorGlassNames();
      }
    });

    // This should be removed when Cadcraft fixes a bug that adds
    // currentcloned elements to save data
    parts = parts.filter(
      (part: any) => part.name.split('_')[0] !== 'currentcloned'
    );

    if (parts.length !== 0) {
      window.CreateWallLineAndConnectionFromJson(parts);
    }

    callback();
  });
};

const emptyDoorGlassNames = () => {
  return {
    primaryGlassName: '',
    aboveGlassName: '',
    secondaryGlassName: '',
    sideGlassLeftName: '',
    sideGlassRightName: '',
  };
};

export default openSaveData;
